import { coreAgent } from "../../app/api/agent";

export const deleteSatisfactionSurveyRequest = (id: string) =>
  coreAgent.deleteRequest(`satisfactionSurveys/${id}`);
